export const sortByLabel = (
  option1: { label: string },
  option2: { label: string },
) => (option1.label.toUpperCase() < option2.label.toUpperCase() ? -1 : 1);

const normalizeSearchText = (text: string) =>
  text
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const filterOptionBySearchText = (
  option: { data: { label: unknown; searchText?: string }; value: string },
  input: string,
) => {
  const label =
    option.data.searchText ??
    (typeof option.data.label === 'string' ? option.data.label : '');
  return normalizeSearchText(`${label} ${option.value}`).includes(
    normalizeSearchText(input),
  );
};
